import { Course } from '../../../types/Section';
import { CourseTable } from '../types';

export function adapterCourseData(courseResponseData: Course): CourseTable {
  const {
    id,
    name,
    code,
    credits,
    school,
    modality,
    academicLevel,
    totalHours,
    presentialPedagogicalHours,
    createdAt,
    syllabus,
    hasLearningUnits,
    ...data
  } = courseResponseData;

  const studyplan = data.semesterCourses
    ? data.semesterCourses.map(
        (sC) => sC.semester.curriculum.studyPlanVersion.name,
      )
    : [];

  return {
    id,
    code: code,
    name: name,
    school: school?.name ?? '',
    studyplan: studyplan,
    modality: modality?.name ?? '',
    academicLevel: academicLevel?.name ?? '',
    totalHours: totalHours ?? '',
    presentialPedagogicalHours:
      presentialPedagogicalHours != null
        ? String(presentialPedagogicalHours)
        : '',
    credits: credits,
    createdAt: createdAt ? String(createdAt) : undefined,
    hasLearningUnits: Boolean(hasLearningUnits),
    syllabusUrl: syllabus?.url,
  };
}
